import { DetailBox } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { formatDate } from '../../../utils/dates';

type ModalAddActivityDetailsProps = {
  prefix: string;
  className?: string;
  classDate?: string;
};

const ModalAddActivityDetails = ({
  prefix,
  className,
  classDate,
}: ModalAddActivityDetailsProps) => {
  const { t } = useTranslation(TranslationsKeys.CLASSES_BOOK_EDIT);

  return (
    <div className="d-flex w-100 justify-content-end">
      <div style={{ width: 'max-content' }}>
        <DetailBox
          columns={[
            {
              title: t(`${prefix}.details.className`),
              body: className ?? 'N/D',
            },
            {
              title: t(`${prefix}.details.classDate`),
              body: classDate ? formatDate(classDate, 'DD/MM/YYYY') : 'N/D',
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ModalAddActivityDetails;
